import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import styles from './styles.module.css';
import { constants } from '../Helpers/constantsFile';

const SubMenu = ({ item }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [subnav, setSubnav] = useState(false);
  const [hovered, setHovered] = useState(false);

  // Determine if the current tab is active
  const isActive = location.pathname.startsWith(item.path);

  const tabStyle = {
    // The tooltip measures itself against this row.
    position: "relative",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: "black",
    cursor: "pointer",
    border: isActive && "1px solid lightGrey",
    // background: isActive && "#9300FF"
    background: isActive && constants.activeTabColor
  };

  const subTabStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    marginLeft: "40px",
    color: "black",
    fontWeight: isActive && "bold",
    cursor: "pointer"
  };

  // Show subnav when the tab is active
  React.useEffect(() => {
    if (isActive) {
      setSubnav(true);
    } else {
      setSubnav(false);
    }
  }, [isActive]);

  return (
    <>
      <div className={styles.container}
        style={tabStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => {
          navigate(item.path);
        }}>
        <div style={{ display: "flex", gap: "15px" }} onClick={() => {
          // Only toggle subnav state when clicking on the icon
          if (item.subNav) {
            setSubnav(!subnav);
          }
        }}>
          {item.icon}
          <Typography> {item.text}</Typography>
        </div>

        {item.subNav && subnav
          ? item.iconOpened
          : item.subNav
            ? item.iconClosed
            : null}

        {/*
          The name, on hover.

          The rail is 65px wide until it is expanded, so the label beside every
          icon is clipped and the tabs are told apart by icon alone. This is
          that label, floated clear of the rail where nothing can cut it off.
        */}
        {hovered ? <TabTooltip label={item.text} /> : null}
      </div>
      {subnav &&
        item.subNav?.map((subItem, index) => { // <-- Optional chaining added here
          // Only render subtab if the parent tab is active
          return isActive && (
            <div className={styles.subContainer}
              key={index}
              style={subTabStyle} onClick={() => {
                navigate(subItem.path);
              }}>
              {subItem.icon}
              <Typography> {subItem.text}</Typography>
            </div>
          );
        })}
    </>
  );
};

/**
 * A small dark box beside the icon.
 *
 * Fixed rather than absolute, and positioned from the row's own box on screen:
 * the drawer sets `overflow-x: hidden`, so an absolutely positioned tooltip
 * would be trimmed at the same 65px as the text it exists to replace.
 *
 * Measured in a layout effect, so it is placed before the browser paints and
 * never appears in the corner first. It reads the row from its own parent
 * rather than taking a ref, which keeps the change to the row above to two
 * mouse handlers.
 */
function TabTooltip({ label }) {
  const [box, setBox] = useState(null);
  const anchor = React.useRef(null);

  React.useLayoutEffect(() => {
    const row = anchor.current && anchor.current.parentElement;
    if (!row) return;

    const rect = row.getBoundingClientRect();
    setBox({ top: rect.top + rect.height / 2, left: rect.right + 10 });
  }, []);

  return (
    <span ref={anchor} style={{ position: "absolute", width: 0, height: 0 }}>
      {box ? (
        <span
          role="tooltip"
          style={{
            position: "fixed",
            top: box.top,
            left: box.left,
            transform: "translateY(-50%)",
            zIndex: 1400,
            padding: "6px 11px",
            background: "#15181D",
            borderRadius: "6px",
            fontSize: "12.5px",
            fontWeight: 600,
            lineHeight: 1.2,
            color: "#FFFFFF",
            whiteSpace: "nowrap",
            boxShadow: "0 6px 18px rgba(21,24,29,0.18)",
            // Never under the pointer, so hovering the tooltip cannot make the
            // row think the pointer has left it.
            pointerEvents: "none",
          }}
        >
          {label}
        </span>
      ) : null}
    </span>
  );
}

export default SubMenu;
